import React from 'react';
import { Form } from 'semantic-ui-react';
import ReactCountryFlag from 'react-country-flag';
import { createStyles, withStyles } from '@material-ui/core/styles';

import FilterCardKeyArray from '../FilterComponents/FilterCardKeyArray';
import FilterCardSelect from '../FilterComponents/FilterCardSelect';
import FilterCardSelectArray from '../FilterComponents/FilterCardSelectArray';
import FilterCardSelectRef from '../FilterComponents/FilterCardSelectRef';

import FilterAdTypes from '../../StaticData/FilterAdTypes';
import FilterProtocols from '../../StaticData/FilterProtocols';

const styles = createStyles({
  cookie: {
    display: 'inline-block',
    verticalAlign: 'top'
  }
});

type CountryFlagProps = {
  record: any
};

const CountryNameWithFlag = (props: CountryFlagProps) => (
  <span>
    <ReactCountryFlag code={props.record.id} /> {props.record.name} ({props.record.id})
  </span>
);

type Props = {
  record: any,
  resource: string
};

const CommonFiltersColumn2 = (props: Props) => (
  <div>
    <Form.Field>
      <FilterCardSelectRef
        optionText={<CountryNameWithFlag record={props.record} />}
        reference="helpers/countries"
        resource={props.resource}
        rootName="segment_attributes.filter_country_attributes"
        sort={{ field: 'name', order: 'ASC' }}
        title="Countries"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_country_attributes && props.record.segment_attributes.filter_country_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelectRef
        reference="helpers/browsers"
        resource={props.resource}
        rootName="segment_attributes.filter_browser_attributes"
        sort={{ field: 'name', order: 'ASC' }}
        title="Browsers"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_browser_attributes && props.record.segment_attributes.filter_browser_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelectRef
        reference="helpers/ad_sizes"
        resource={props.resource}
        rootName="segment_attributes.filter_ad_size_attributes"
        sort={{ field: 'name', order: 'ASC' }}
        title="Ad Sizes"
        values={props.record.segment_attributes &&
          props.record.segment_attributes.filter_ad_size_attributes &&
          props.record.segment_attributes.filter_ad_size_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelectRef
        reference="helpers/device_types"
        resource={props.resource}
        rootName="segment_attributes.filter_device_type_attributes"
        sort={{ field: 'name', order: 'ASC' }}
        title="Device Types"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_device_type_attributes && props.record.segment_attributes.filter_device_type_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelect
        choices={FilterProtocols}
        record={props.record}
        rootName="segment_attributes.filter_protocol_attributes"
        title="Protocol"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_protocol_attributes && props.record.segment_attributes.filter_protocol_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelectArray
        choices={FilterAdTypes}
        rootName="segment_attributes.filter_ad_type_attributes"
        title="Ad Type"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_ad_type_attributes && props.record.segment_attributes.filter_ad_type_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardKeyArray
        popoverContent={[<div style={{ fontWeight: 'bold' }}>Examples</div>, <br />, 'up_45=A968827C-42E5-4112-BBBB-4926A0DFB431 => targets cookie name and value', <br />, <br />, 'up_45=A968827C-42E5-4112-BBBB-4926A0DFB431, up_9=59a99c7c-fd2a-11e7-9a34-02db07ef26be => targets multiple cookies by name and value ("OR" logical expression)', <br />, <br />, '^up_45 => targets cookie by its name only']}
        record={props.record}
        rootName="segment_attributes.filter_cookie_attributes"
        title="Cookies"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_cookie_attributes && props.record.segment_attributes.filter_cookie_attributes.values} /><br />
    </Form.Field>
  </div>
);

export default withStyles(styles)(CommonFiltersColumn2);



// WEBPACK FOOTER //
// ./src/views/Common/Filters/Column2.tsx